import createBasket from "core-web/state/models/Basket/dispatches/createBasket";
import getBasketIdCookie from "./getBasketIdCookie";
import { getState } from "core-web/state";

export default async () => {
    let basketId = getState("basket").basketId || getBasketIdCookie() || null;
    if (!basketId || basketId === "undefined") {
        const response = await createBasket();
        basketId = response.data.id;
    }
    return basketId;
};
